import React from "react";
import { useAuth } from "../../context/AuthContext";
import { FaArrowRight, FaCheckCircle, FaRocket } from "react-icons/fa";
import { APP_CONFIG, ROUTES } from "../../utils/constants";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const { isAuthenticated } = useAuth();

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-white to-indigo-50 pt-32 pb-24 px-6">

      {/* background glow */}
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-blue-400/20 blur-3xl rounded-full"></div>
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-purple-400/20 blur-3xl rounded-full"></div>

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

        {/* LEFT CONTENT */}
        <div>

          {/* badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
            <FaRocket />
            {APP_CONFIG.HOME_CONTENT.HERO.BADGE_TEXT}
          </div>

          {/* heading */}
          <h1 className="text-5xl md:text-6xl font-bold leading-tight text-gray-900 mb-6">
            {APP_CONFIG.HOME_CONTENT.HERO.HEADING}
            <span className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
              {APP_CONFIG.HOME_CONTENT.HERO.HEADING_HIGHLIGHT}
            </span>
          </h1>

          {/* subheading */}
          <p className="text-lg text-gray-600 mb-10 max-w-xl">
            {APP_CONFIG.HOME_CONTENT.HERO.SUBHEADING}
          </p>

          {/* buttons */}
          <div className="flex flex-wrap gap-4 mb-10">

            {isAuthenticated ? (
              <Link
                to={ROUTES.DASHBOARD}
                className="flex items-center gap-2 px-7 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition shadow-lg"
              >
                {APP_CONFIG.HOME_CONTENT.HERO.CTA_AUTHENTICATED}
                <FaArrowRight />
              </Link>
            ) : (
              <>
                <Link
                  to={ROUTES.REGISTER}
                  className="flex items-center gap-2 px-7 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition shadow-lg"
                >
                  {APP_CONFIG.HOME_CONTENT.HERO.CTA_PRIMARY}
                  <FaArrowRight />
                </Link>

                <Link
                  to={ROUTES.LOGIN}
                  className="px-7 py-3 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-100 transition font-semibold"
                >
                  {APP_CONFIG.HOME_CONTENT.HERO.CTA_SECONDARY}
                </Link>
              </>
            )}

          </div>

          {/* indicators */}
          <div className="grid grid-cols-2 gap-4 max-w-md">

            {APP_CONFIG.TRUST_INDICATORS.map((indicator, index) => (
              <div key={index} className="flex items-center gap-2 text-gray-700">
                <FaCheckCircle className="text-green-500" />
                <span className="text-sm">{indicator}</span>
              </div>
            ))}

          </div>
        </div>


        {/* RIGHT SIDE VISUAL */}
        <div className="relative">

          <div className="bg-white/70 backdrop-blur-xl border border-gray-200 rounded-2xl shadow-xl p-8">

            <div className="space-y-4">

              <div className="flex justify-between items-center border-b pb-3">
                <span className="font-semibold text-gray-800">
                  Platform Overview
                </span>
                <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded">
                  Live
                </span>
              </div>

              <div className="space-y-3">

                <div className="p-4 rounded-lg bg-blue-50 flex justify-between">
                  <span className="text-sm text-gray-700">Components</span>
                  <span className="font-semibold text-blue-600">120+</span>
                </div>

                <div className="p-4 rounded-lg bg-purple-50 flex justify-between">
                  <span className="text-sm text-gray-700">Developers</span>
                  <span className="font-semibold text-purple-600">5k+</span>
                </div>

                <div className="p-4 rounded-lg bg-indigo-50 flex justify-between">
                  <span className="text-sm text-gray-700">Downloads</span>
                  <span className="font-semibold text-indigo-600">25k+</span>
                </div>

              </div>

            </div>

          </div>

          {/* floating decoration */}
          <div className="absolute -top-6 -right-6 w-16 h-16 bg-blue-500 rounded-xl opacity-20 rotate-12"></div>
          <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-purple-500 rounded-xl opacity-20 -rotate-12"></div>

        </div>

      </div>
    </section>
  );
};

export default HeroSection;